import { api } from '@/api';
import router from '@/router';
import { AxiosError } from 'axios';
import { getStoreAccessors } from 'typesafe-vuex';
import { ActionContext } from 'vuex';
import { State } from '../state';
import {
    commitSetUserTasksResponse, commitSetUserTicketDetail, commitSetUserTicketsResponse,
} from './mutations';
import { UserTasksState } from './state';
import { dispatchCheckApiError } from '../main/actions';

type MainContext = ActionContext<UserTasksState, State>;

export const actions = {
    async actionGetUserTasksResponse(
        context: MainContext,
        payload: {
            rowQuery: string,
            data: { mode?: string, linker_user_id?: number, view_user_id?: any},
        },
    ) {
        try {
            const response = await api.getUserTasksList(context.rootState.main.token, payload.data, payload.rowQuery);
            if (response.data) {
                commitSetUserTasksResponse(context, response.data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async actionGetUserTicketsResponse(
        context: MainContext, payload: { rowQuery: string, data: { user_id?: number}},
    ) {
        try {
            const response = await api.getUserTicketsList(context.rootState.main.token, payload.data, payload.rowQuery);
            if (response.data) {
                commitSetUserTicketsResponse(context, response.data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async actionGetTicketDetail(
        context: MainContext, payload: { ticket_id: number},
    ) {
        try {
            const response = await api.getTicketDetail(context.rootState.main.token, payload);
            if (response.data) {
                commitSetUserTicketDetail(context, response.data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
};

const { dispatch } = getStoreAccessors<UserTasksState | any, State>('');

export const dispatchGetUserTasksResponse = dispatch(actions.actionGetUserTasksResponse);
export const dispatchGetUserTicketsResponse = dispatch(actions.actionGetUserTicketsResponse);
export const dispatchGetTicketDetail = dispatch(actions.actionGetTicketDetail);
